// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"Confirm_modal_wrapper__KugJz","actionWrapper":"Confirm_actionWrapper__wLsHU","textWrapper":"Confirm_textWrapper__PzRQy","text":"Confirm_text__xkL02"};